<h1 mat-dialog-title> Valida Postulación Catastrofe </h1> <br/>

<mat-dialog-content>
  
    <p>
        <mat-form-field appearance="outline" class="mat-input">

            <p> Beneficiario </p>

            <mat-select *ngIf="data.carga" [(ngModel)]="data.beneficiario" [disabled]="data.deshabilitado" required>

                <mat-option *ngFor="let postulante of data.postulantes" value="{{postulante.id}}">

                    {{postulante.rut}} - {{postulante.dv}} {{postulante.nombres}} {{postulante.apellidoPaterno}}

                </mat-option>

            </mat-select>

            <input *ngIf="!data.carga" matInput [disabled]="true" [value]="data.beneficiario" />

        </mat-form-field>
    </p>
    <form #catastrofeForm=ngForm>
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-8">
                <h2> Vivienda Principal </h2>
            </div>

            <div class="col-lg-3"> </div>

        </div>
        <br />
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3"> <label> Domicilio </label> </div>
            <div class="col-lg-5">
                <input id="domicilioCatastrofe" name="domicilioCatastrofe" #nombres="ngModel"
                    [(ngModel)]="data.domicilioCatastrofe" class="form-control" [disabled]="data.deshabilitado" required type="text"
                    placeholder="Ingrese su dirección" />
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />
        <div class="row">
            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Región </label> </div>
        
            <div class="col-lg-5">

                <mat-select class="form-control" name="region" #region="ngModel" 
                [(value)]="data.region" [(ngModel)]="data.region"  [disabled]="data.deshabilitado" (selectionChange)="traeComunas()" required>
                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let region_ of data.regiones" [value]="region_.codigo">
                        {{region_.nombre}}
                    </mat-option>

                </mat-select>
            </div>
           
        </div>
        <br />
        <div class="row">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3"> <label> Ciudad </label> </div>

            <div class="col-lg-5">
                <mat-select class="form-control" name="comuna" #comuna="ngModel" [(ngModel)]="data.ciudad" [disabled]="data.deshabilitado"
                    required>
                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let comuna of data.comunas" [value]="comuna.codigo">

                        {{comuna.nombre}}

                    </mat-option>

                </mat-select>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-8">
                <h2> Datos Catástrofe </h2>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />          
        <div class="row line">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <p> Fecha Catástrofe </p>
            </div>
            <div class="col-lg-5">
                <input class="form-control" id="fechaCatastrofe" name="fechaCatastrofe" #fechaCatastrofe="ngModel" [disabled]="data.deshabilitado"
                [(ngModel)]="data.fechaCatastrofe"  required type="date">
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />
        <div class="row">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3">
                <label> Tipo Catástrofe </label>
            </div>
            <div class="col-lg-6">
                <mat-select class="form-control" name="tipoCatastrofe" #tipoCatastrofe="ngModel"  (selectionChange)="muetraOtros(data.tipoCatastrofe)"
                    [(ngModel)]="data.tipoCatastrofe" [(value)]="data.tipoCatastrofe" required [disabled]="data.deshabilitado">

                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipo of data.tipos"  [value]="tipo.id">
                        {{tipo.descripcion}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-lg-2"> </div>
        </div>
        <br />
        <div class="row" *ngIf="data.otro == true" >
            <div class="col-lg-1"> </div>
            <div class="col-lg-3"> <label> Otro tipo catastrofe </label> </div>
            <div class="col-lg-5">
                <input id="otroTipoCatastrofe" name="otroTipoCatastrofe" #nombres="ngModel"
                    [(ngModel)]="data.otroTipoCatastrofe" class="form-control" required type="text"
                    placeholder="Ingrese otro tipo de catastrofe" />
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br /> 

        <div class="row" *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || this.data.rol == 'ROLE_COORDINADOR'">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <label> Magnitud del daño</label>             
            </div>
            <div class="col-lg-6">
                <mat-select class="form-control" name="magnitudDanno" #magnitudDanno="ngModel"  
                    [(ngModel)]="data.magnitudDanno" [(value)]="data.magnitudDanno" required [disabled]="data.deshabilitado">

                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipos of data.magnitudesDannos"  [value]="tipos.id">
                        {{tipos.descripcion}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-lg-2"> </div>
        </div>
        <br />
        <div class="row"  *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || this.data.rol == 'ROLE_COORDINADOR'">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3"> <label> Característica  de la vivienda</label> </div>
            <div class="col-lg-5">             
                <textarea name="caracteristicasVivienda" id="caracteristicasVivienda"  [(ngModel)]="data.caracteristicasVivienda" class="form-control" required [disabled]="data.deshabilitado" 
                placeholder="Ingrese caracteristicas de la vivienda" required cols="55" rows="5">
                </textarea>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

        <div class="row" *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || this.data.rol == 'ROLE_COORDINADOR'">

            <div class="col-lg-1"> </div>

            <div class="col-lg-3">
                <label> Tipo Vivienda </label>
            </div>
            <div class="col-lg-6">
                <mat-select class="form-control" name="tipoVivienda" #tipoVivienda="ngModel" 
                    [(ngModel)]="data.tipoVivienda" [(value)]="data.tipoVivienda" required [disabled]="data.deshabilitado">

                    <mat-option value="0">
                        SELECCIONE....
                    </mat-option>
                    <mat-option *ngFor="let tipo of data.tiposVivienda"  [value]="tipo.id">
                        {{tipo.descripcion}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-lg-2"> </div>
        </div>
        <br />

        <div class="row"  *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || this.data.rol == 'ROLE_COORDINADOR'">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3"> <label> visita Domiciliaria </label> </div>
            <div class="col-lg-5">             
                <textarea name="visitaDomiciliaria" id="visitaDomiciliaria"  [(ngModel)]="data.visitaDomiciliaria" class="form-control" [disabled]="data.deshabilitado" Magnitud del daño 
                placeholder="visita domiciliaria" required cols="55" rows="5">
                </textarea>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />

        <div class="row"  *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_ENCARGADO_REGIONAL'  || this.data.rol == 'ROLE_ENCARGADO_REGIONAL_CONTABLE' || this.data.rol == 'ROLE_COORDINADOR'">
            <div class="col-lg-1"> </div>
            <div class="col-lg-3"> <label>Observación Catastrofe </label> </div>
            <div class="col-lg-5">             
                <textarea name="observacionCatastrofe" id="observacionCatastrofe"  [(ngModel)]="data.observacionCatastrofe" class="form-control" [disabled]="data.deshabilitado" 
                placeholder="ingrese observaciones" required cols="55" rows="5">
                </textarea>
            </div>
            <div class="col-lg-3"> </div>
        </div>
        <br />
        

    <p>
        <button class="btn-info mat-raised-button" (click)="onDescargarArchivosClick(data.idPostulacion)">

        <i class = "fa fa-download"> </i> Descargar Archivos Ingresado </button>
    </p>

    
    <div class="row ">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar </p>
        </div>

        <div class="col-lg-5">

            <input type="file" class="form-control-file" name="archivo" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest"
                (change)="seleccionaArchivo($event, 0)" [disabled]="data.deshabilitado">

        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button [disabled]="data.deshabilitado" class="btn btn-info"
                (click)="sumaArchivo()"> + </button> </div>
        <div class="col-lg-1"> </div>

    </div>
    <br />

    <div *ngIf="data.cantidadArchivos > 1" class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar (2) </p>
        </div>

        <div class="col-lg-5">
            <input type="file" class="form-control-file" name="archivo2" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest2"
                (change)="seleccionaArchivo($event, 1)">
        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

        <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

    </div>
    <br />
    <div *ngIf="data.cantidadArchivos > 2" class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar (3) </p>
        </div>

        <div class="col-lg-5">
            <input type="file" class="form-control-file" name="archivo3" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest3"
                (change)="seleccionaArchivo($event, 2)">
        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

        <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

    </div>
    <br />
    <div *ngIf="data.cantidadArchivos > 3" class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar (4) </p>
        </div>

        <div class="col-lg-5">
            <input type="file" class="form-control-file" name="archivo4" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest4"
                (change)="seleccionaArchivo($event, 3)">

        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

        <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

    </div>
    <br />
    <div *ngIf="data.cantidadArchivos > 4" class="row line">

        <div class="col-lg-1"> </div>

        <div class="col-lg-3">
            <p> Adjuntar (5) </p>
        </div>

        <div class="col-lg-5">

            <input type="file" class="form-control-file" name="archivo5" required
                accept="application/pdf, image/jpeg, image/jpg, image/png" [(ngModel)]="data.archivoTest5"
                (change)="seleccionaArchivo($event, 4)">
        </div>

        <div class="col-lg-1"> </div>

        <div class="col-lg-1"> <button class="btn btn-info" (click)="sumaArchivo()"> + </button> </div>

        <div class="col-lg-1"><button class="btn btn-danger" (click)="restaArchivo()"> - </button> </div>

    </div>
</form>
</mat-dialog-content> <br/>

<mat-dialog-actions>
    <div *ngIf="data.rol != 'ROLE_EJECUTIVO_CAIP';  else roleReadOnly">
        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-warning" (click)="onEditarClick()">
            <i class ="fa fa-pen"> </i> Editar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.mostrarAprobarButton" mat-button class="mat-raised-button btn-success" (click)="onAprobarClick(catastrofeForm)">
            <i class = "fa fa-check"> </i> Aprobar
        </button>

        <button *ngIf="!data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-danger" (click)="onRechazarClick()">
            <i class = "fa fa-times"> </i> Rechazar
        </button>

        <button *ngIf="data.presionaEditar && data.mostrarEditar && data.disponiblePago" mat-button class="mat-raised-button btn-success" (click)="onGuardarClick(catastrofeForm)">
            <i class = "fa fa-download"> </i> Guardar
        </button>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </div>

    <ng-template #roleReadOnly>
        <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()">
            <i class = "fa fa-trash"> </i> Salir
        </button>
    </ng-template>

</mat-dialog-actions>